// extracted by mini-css-extract-plugin
module.exports = {"section":"ReferenceUrls_section__1SVZs","disabled":"ReferenceUrls_disabled__xmxpr"};